export default {
  title: 'Indian Pregnancy, baby and conception information at Mylo',
  description: 'Indian Pregnancy, baby and conception information at Mylo',
  openGraph: {
    title: 'Indian Pregnancy, baby and conception information at Mylo',
    description: 'Indian Pregnancy, baby and conception information at Mylo',
    type: 'website',
    locale: 'en_US',
    url: 'https://mylofamily.com/',
    site_name: 'Mylo - Raise Happiness',
  },
};
